module.exports = __webpack_public_path__ + "img/58.79f6c373.svg";